const secondaryImage = {
  active: false,
  id: null,
  url: null,
  type: null,
};

const checkerboarder = {
  active: false,
  resultImageDataURL: null,
  originalImageFile: null,
  originalImageUrl: null,
};

const views = [
  "ugcentrypointTermsAndConditions",
  "ugcentrypointCheckerboarder",
  "ugcentrypointStyleSelection",
  "ugcentrypointSizeSelection",
];

export { secondaryImage, checkerboarder, views };
